import { SKU_RESTRICTION_TYPES } from 'constants/SKUs';

export const isValidSKU = sku => Object.values(SKU_RESTRICTION_TYPES).includes(sku);
